/** Wiederverwendbarer debounced Scheduler (clear + reschedule). */
export function createDebouncedScheduler(delayMs) {
  let timeoutId = null;

  return {
    schedule(callback) {
      if (timeoutId != null) {
        clearTimeout(timeoutId);
      }
      timeoutId = setTimeout(() => {
        timeoutId = null;
        callback();
      }, delayMs);
    },
    cancel() {
      if (timeoutId != null) {
        clearTimeout(timeoutId);
        timeoutId = null;
      }
    }
  };
}
